import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-Y0765X22CH';

function init() {
  // Enable debug mode on the local development environment
  const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

  ReactGA.initialize(TRACKING_ID, {
    gtagOptions: {
      debug_mode: isDev,
    },
  });
}

function sendEvent(payload) {
  ReactGA.event(payload);
}

function sendPageview(path) {
  ReactGA.send({ hitType: 'pageview', page: path });
}

export default {
  init,
  sendEvent,
  sendPageview,
};
